import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { isTruthy, isBridgAdmin } from 'lib/Helpers';
import { toggleApplicationErrorState } from 'modules/App';

import * as styles from './ErrorPage.scss';

/**
 * Error Page Component
 * @function ErrorPage
 * @param {Object} props
 * @return {ReactElement}
 */
const ErrorPage = ({ errorPayload }) => {
  const { message, stack } = errorPayload;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.app.user);
  const account = useSelector((state) => state.app.account);
  const brand = useSelector((state) => state.app.brand);
  const navigate = useNavigate();

  const isAuthorizedToViewErrors = isBridgAdmin(user);

  const resetAndRedirect = () => {
    dispatch(toggleApplicationErrorState(false));
    return navigate(`/${account.sid}/${brand.sid}/`);
  };

  return (
    <div className={styles.errorPage}>
      <div className={styles.contentContainer}>
        <span className={styles.title}>Sorry, there was an error.</span>
        <div className={styles.refreshContainer}>
          <p className={styles.text}>Please refresh and try again or return to</p>
          <a className={styles.linkText} onClick={resetAndRedirect}>Brand Home</a>
        </div>
      </div>
      {isTruthy(isAuthorizedToViewErrors) &&
        <Paper className={styles.errorContainer}>
          <div className={styles.messageContainer}>
            <span className={styles.errorLeadText}>Error Message: </span>
            <span className={styles.message}>{message}</span>
          </div>
          <div className={styles.stackContainer}>
            <span className={styles.errorLeadText}>Error Stack: </span>
            <div className={styles.stackItemsContainer}>
              {stack?.map((stackEl, i) => <span className={styles.message} key={i}>{stackEl}</span>)}
            </div>
          </div>
        </Paper>}
    </div>
  );
};

export default ErrorPage;
